import Immutable from 'seamless-immutable';
import { User } from '../stores';
import { UserActions } from '../actions';

const initialState = Immutable(User);

export function user(state = initialState, action) {
	switch (action.type) {
		case UserActions.FetchUsersAction.Success: {
			return state.merge({ users: action.payload });
		}
		case UserActions.FetchUserAction.Success: {
			return state.merge({ user: action.payload });
		}
		case UserActions.UnloadUserAction.Success: {
			return state.merge({ user: null });
		}
		default: {
			return state;
		}
	}
}
